import React, { useContext, useEffect, useState } from 'react';
import { QuizIntroduction } from './../../components/QuizIntroduction';
import { QuizQuestion } from './../../components/QuizQuestion';
import gameContext from './../../contexts/gameContext'; 
import { chiQuestionHelper, goToFn } from 'quiz-questions-helpers'
import cloneDeep from 'lodash/cloneDeep';
import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';

export const QuizContainer = () => {
    const { config, modules, message, el } = useContext(gameContext);
    let [firstLoad, setFirstLoad] = useState(true)
    
    const quizConfig = (config.quiz || {})
    let startIndex = quizConfig.showIntro ? -1 : 0
    let systemId = message.systemId
    let overwriteIndex = lodashGet(modules.realDevice, "variables.quizContainerPackage.systemId_"+systemId+".currentPosition")
    
    if(overwriteIndex && firstLoad && config.quiz.rememberPositionForQuiz){
        console.log('Continued to index : ', overwriteIndex)
        startIndex = overwriteIndex
        setFirstLoad(false)
    }
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState({ index:  startIndex , history : [] });
    let quizModules = []
    const enableThreeRadicalNavigationOnElement = quizConfig.enableThreeRadicalNavigationOnElement || false
    
    if (enableThreeRadicalNavigationOnElement && !el.threeRadicalNavigation) {
        el.threeRadicalNavigation = {
            goTo: goToFn(config, { currentQuestionIndex, setCurrentQuestionIndex })
        }
    }
    
    for(let questionIndex = 0; questionIndex < config.questions.length; questionIndex++) {
        let question = config.questions[questionIndex],
            questionMessage = modules.realDevice.allMessages.filter(m => m.systemId === Number(question.question.systemId))[0] || null,
            questionContext = {
                realDevice: modules.realDevice,
                containerNavigation: modules.navigation,
                message,
                currentQuestionIndex,
                setCurrentQuestionIndex
            },
            questionHelper = new chiQuestionHelper(config, questionContext, questionIndex),
            questionNavigation = {
                next: () => {
                    console.log("navigation.next", questionIndex)
                    questionHelper.resolveNextQuestion(null)
                },
                prev: () => {
                    console.log("navigation.prev", questionIndex)
                    let prevIndex = currentQuestionIndex.history.pop()
                    setCurrentQuestionIndex({ index : prevIndex, history : currentQuestionIndex.history })
                    questionHelper.resolveNextQuestion(null)
                }
            }
        
        let subPackageModules = modules.subPackage.moduleFactory(
            modules, 
            questionMessage,
            questionHelper.triggerOutcome,
            questionNavigation
        )
        
        quizModules.push(subPackageModules)
    }

    const startPlay = () => {
        setCurrentQuestionIndex({ index: currentQuestionIndex.index + 1, history : [] })
    }  
    
    useEffect(() => {
        //Warning: Jumping back to an already redeemed question with nextOnRedeem on will trigger the skip
        if(config.quiz.nextOnRedeem) {
            let alreadyRedeemedMessages = []
            modules.realDevice.on('messages', ((messages) => {
                //Makes sure nextOnRedeem only happens when there are still questions to parse through
                if(currentQuestionIndex.index < config.questions.length) {
                    let currentQuizModule = quizModules[currentQuestionIndex.index]
                    let currentShownMessage = quizModules[currentQuestionIndex.index]?.device?.message
                    //If more than one message is redeemed at the same time, will only process one due to the asynchronous nature of the logic below AND of setCurrentQuestionIndex
                    messages.forEach(message => {
                        if(!alreadyRedeemedMessages.includes(message?.ATTRIBUTES?.id)) {
                            if(currentShownMessage?.ATTRIBUTES?.id == message?.ATTRIBUTES?.id && message?.ATTRIBUTES?.status == 'redeemed') {
                                alreadyRedeemedMessages.push(message.ATTRIBUTES.id)
                                currentQuizModule.navigation.next()
                            }
                        }
                    })
                }
            }))
        }    
    }, [])
    
    
    useEffect(() => {
        let prefetchImages = []
        if(currentQuestionIndex.index >= 0 && config.quiz.prefetchImages){
            
            let futureMessages = modules.realDevice.allMessages.find(item => item?.systemId == config.questions[currentQuestionIndex.index + 1]?.question?.systemId)
            
            let threeRadical = ((((futureMessages?.quantities || {}).link || {}).data || {}).externalPackage || {}).threeRadical
            
            if(threeRadical){
                prefetchImages = resolveImagePath(threeRadical)
            }
            
            prefetchImages.push(futureMessages?.heroImage, futureMessages?.offerImage)
            
            prefetchImages.map(images => {
                const img = new Image();
                img.src = images;
            })
        }
        
        prefetchImages = []
        
    },[currentQuestionIndex])
    
    const resolveImagePath = (parentObj) => {
        let images = []
        
        Object.keys(parentObj).forEach(key => {
            if(typeof parentObj[key] === 'object' && parentObj[key].length == undefined) {
                const { type, value } = parentObj[key]
                if (type && type === 'Image') {
                    if (value) images.push(value)
                } else {
                    images.push(...resolveImagePath(parentObj[key]))
                }
            }
        })
    
        return images
    }

    return (
        <>
            {currentQuestionIndex.index == -1 && 
            <div className="container">
                <QuizIntroduction onPlayStarted={startPlay} ></QuizIntroduction>
            </div>
            }           

            {currentQuestionIndex.index > -1 && currentQuestionIndex.index < config.questions.length &&
                <QuizQuestion 
                    animationType={config.animationType} 
                    animationDuration={config.animationDuration} 
                    animationBackgroundColor={config.animationBackgroundColor}
                    message={message} 
                    modules={quizModules[currentQuestionIndex.index]} 
                    question={config.questions[currentQuestionIndex.index]} 
                    questionIndex={currentQuestionIndex}></QuizQuestion>
            } 

            {currentQuestionIndex.index > -1 && currentQuestionIndex.index == config.questions.length &&
                <div>Finish</div>
            }
        </>
    )
    
    function copyObj(to, from) {
        for (let k in from) {
            if (from.hasOwnProperty(k)) {
                to[k] = from[k]
            }
        }
        
        return to
    }
}
